import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { isFormHost } from "@/lib/api";
import FormRunner from "@/components/forms/FormRunner";
import ErrorBoundary from "@/components/ErrorBoundary";
import BookingPage from "@/pages/BookingPage";

const shuffle = (a) => { const r = [...a]; for (let i = r.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [r[i], r[j]] = [r[j], r[i]]; } return r; };
const randomize = (blocks) => blocks.map((b) => ({
  ...b, options: b.randomize && b.options ? shuffle(b.options) : b.options, children: b.children ? randomize(b.children) : b.children,
}));


export default function PublicForm() {
  const { slug } = useParams();
  const [form, setForm] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/public/forms/${slug}`).then((r) => { setForm({ ...r.data, blocks: randomize(r.data.blocks || []) }); document.title = r.data.title; })
      .catch(() => setErr("This form isn't available."));
  }, [slug]);
  if (err && isFormHost() && window.location.pathname === `/${slug}`) return <BookingPage slug={slug} />;
  if (err) return <div className="min-h-screen bg-black text-neutral-400 flex items-center justify-center" data-testid="public-form-error">{err}</div>;
  if (!form) return <div className="min-h-screen bg-black" />;
  return (
    <ErrorBoundary message="Something went wrong loading this form.">
      <FormRunner form={form} />
    </ErrorBoundary>
  );
}
